module.exports = __webpack_public_path__ + "static/media/eurasian_hunter_gatherers_icon_medium.45001b82.png";